// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__WVyO_","row":"styles_row__1fSuy"};